import { FunctionComponent } from 'react';
import Button from '../../../../../Button';
import classNames from 'classnames';
import styles from './styles.module.scss';

export const SoldOutButton: FunctionComponent = () => {
    return (
        <Button disabled aria-disabled className={classNames(styles.soldOutButton)}>
            Sold Out
        </Button>
    );
};
